import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable, tap } from 'rxjs';
import { DynamicFormComponent } from 'src/app/components/dynamic-form/dynamic-form.component';
import { IFormDialogContent } from 'src/app/shared/interfaces/IFormDialog';
import { ProcessService } from 'src/app/services/process.service';
import { SystemService } from 'src/app/services/system.service';
import { ToastService } from 'src/app/services/toast.service';
import { FormControlType } from 'src/app/shared/enums';
import { IFormConfig } from 'src/app/shared/interfaces/IForm';

@Component({
  selector: 'app-add-dataset-form',
  imports: [DynamicFormComponent],
  templateUrl: './add-dataset-form.component.html',
  host: { class: 'block h-full' }
})
export class AddDatasetFormComponent implements OnInit, IFormDialogContent<unknown> {
  @ViewChild(DynamicFormComponent) private dynamicForm?: DynamicFormComponent;

  form: FormGroup;
  formConfig: IFormConfig;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly translateService: TranslateService,
    private readonly toastService: ToastService,
    private readonly systemService: SystemService,
    private readonly processService: ProcessService
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id: [null],
      datasetMainName: [null, [Validators.required, Validators.maxLength(100)]],
      dataSourceId: [null],
      datasetUnitId: [null],
      description: [null, [Validators.maxLength(7000)]]
    });

    this.formConfig = {
      id: 'addDatasetForm',
      styles: { bodyClass: 'm-0! w-full! py-3!' },
      items: [
        {
          key: 'datasetMainName',
          label: 'name',
          layoutConfig: [{ column: 12 }],
          controlType: FormControlType.INPUT,
          appearance: 'outline',
          validator: [{ errorType: 'required', errorMessage: 'name required' }]
        },
        {
          key: 'dataSourceId',
          label: 'data source',
          layoutConfig: [{ column: 12 }],
          controlType: FormControlType.SELECT,
          appearance: 'outline',
          fetchDataAPI: () => this.systemService.getDataSources({ pageSize: 1000 }),
          selectionConfig: { title: 'name', key: 'id', placeholder: this.translateService.instant('select data source') }
        },
        {
          key: 'datasetUnitId',
          label: 'dataset unit',
          layoutConfig: [{ column: 12 }],
          controlType: FormControlType.SELECT,
          appearance: 'outline',
          fetchDataAPI: () => this.systemService.getDatasetUnits({ pageSize: 1000 }),
          selectionConfig: { title: 'name', key: 'id', placeholder: this.translateService.instant('select unit') }
        },
        {
          key: 'description',
          label: 'description',
          layoutConfig: [{ column: 12 }],
          controlType: FormControlType.TEXTAREA,
          appearance: 'outline',
          inputConfig: { textareaRows: 3 }
        }
      ]
    };
  }

  submit(): Observable<unknown> {
    return this.processService.addOrUpdateProcess(this.form.value).pipe(
      tap(() => this.toastService.success(this.translateService.instant('add successfully')))
    );
  }

  handleSubmitError(error: unknown): void {
    if (!this.dynamicForm) return;

    const backendError = error && typeof error === 'object' && 'error' in error
      ? error.error
      : error;
    this.dynamicForm.ValidatorError = backendError;
  }
}
